<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>Wilde West</span></p>
<p class="authorname"><span>Walter Satterthwait</span></p>
<p class="publisher"><span>A <a href="http://www.mysteriouspress.com" target="_blank">MysteriousPress.com</a></span></p>
<p class="publisher1"><span>Open Road Integrated Media Ebook</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?488e655e